import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef
} from "react";

import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import axios from "axios";
import Wheel from "./Wheel";
import ProgressBar from "./ProgressBar";
import { maximumSession, minimumSession } from "@bd-utils/gameVariable";
import { UserConsumer } from "./Context";
import { Link } from "react-router-dom";
import LanguageOptionMenu from "./LanguageOptionMenu";

const timerArray = [0, 1, 2, 3, 4, 5, 6, 7];
const intervalTime = (maximumSession - minimumSession) / 10;

const Item = props => {
  const [fadeOut, setFadeout] = useState(false);
  const itemStyle = {
    color: window.button_color.text_member_color
  };

  const fadingOut = () => {
    setFadeout(true);
  };

  const onRemoveMember = () => {
    props.removeItem();
    setFadeout(false);
  };
  return (
    <div
      className={`instruction-setup__member-item ${
        fadeOut ? "instruction-setup__member-item--fadeout" : ""
      }`}
      style={itemStyle}
    >
      <div className="instruction-setup__member-name">
        <span>{props.item}</span>
      </div>
      <button className="instruction-setup__member-delete">
        <FontAwesomeIcon
          className="trash-icon"
          icon={faTrash}
          onClick={() => fadingOut(setTimeout(() => onRemoveMember(), 300))}
        />
      </button>
    </div>
  );
};

const introductionScreen = forwardRef(
  (
    {
      isOpen,
      onClose,
      onStart,
      members,
      categoryList,
      wheel,
      teamMembers,
      text,
      next,
      textInstruction,
      langSwitcher,
      instructionPageButton,
      playGameButton,
      isDisable,
      minimumSession,
      maximumSession,
      standardSessionTime,
      onChangeTimer,
      isBlur,
      onOpenPassword,
      onSetPlay,
      login,
      usePassword
    },
    ref
  ) => {
    const [teamName, setTeamName] = useState("");
    const [teamMemberName, setTeamMemberName] = useState("");
    const [isSetupSection, setIsSetupSection] = useState(false);
    const [isOpen_warning, setIsOpen_warning] = useState(false);
    const [isOpen_inputWarning, setOpen_inputWarning] = useState(false);
    const [isAlert, setAlert] = useState("");
    const [isDisabled, setDisabled] = useState(false);
    const [timerValue, setTimerValue] = useState(standardSessionTime);

    const refEl = useRef(null);

    useImperativeHandle(ref, () => ({
      isTeamAction: () => {
        setIsSetupSection(true);
      },
      noTeamAction: () => {
        setIsSetupSection(false);
      },
      isMaxRound: () => {
        setIsOpen_warning(true);
      },
      isMaxAlert: () => {
        setAlert("Maximum time is reached");
      },
      isMaxChar: () => {
        setAlert("Maximum character is reached");
      },
      isMaxTimer: () => {
        setAlert("Maximum time is reached");
      }
    }));

    // const percentCalc = (${timerValue * 100} / (${maximumSession} - ${minimumSession}))
    const percentCalc =
      ((timerValue - minimumSession) * 100) / (maximumSession - minimumSession);

    const [memberList, setMemberList] = useState([]);
    const [isFirstSetup, setIsFirstSetup] = useState(true);
    const [fontClass, setFontClass] = useState(false);

    let textRef = React.createRef();

    const classOpen = isOpen ? "is-open" : "";
    const classBlur = isBlur ? "is-blur" : "";
    const session_total_time = window.sessions?.session_time;
    const useBgImage = Boolean(window.themes.use_background_image);
    const BgImage = window.themes.background_image_theme
      ? window.themes.background_image_theme
      : "";
    const bgColor = window.themes.background_color_theme
      ? window.themes.background_color_theme
      : "#000";
    const bgOpacity = window.themes.overlay_opacity;
    const bgImageStyle = {
      background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity})), no-repeat
        url(${BgImage})`,
      backgroundSize: "cover"
    };
    const bgColorStyle = {
      background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity}))`,
      backgroundColor: bgColor
    };
    const style = useBgImage ? bgImageStyle : bgColorStyle;
    // SETUP TEAM
    const setup_team_subtitle = window.setup_team.subtitle;
    const setup_team_title = window.setup_team.title;
    const setup_team_desc = window.setup_team.desc;
    const setup_team_member_title = window.setup_team.setup_team_member_title;
    const setup_team_member_input_placeholder =
      window.setup_team.setup_team_member_input_placeholder;
    const setup_team_member_input_empty_response =
      window.setup_team.setup_team_member_input_empty_response;

    // WELCOME
    const welcome_title = window.welcome.title_welcome;
    const welcome_subtitle = window.welcome.subtitle_welcome;
    const welcome_text = window.welcome.text_welcome;

    const languageCodes = window.wpml_language_codes?.language_codes || [];

    const onChangeTimerValue = e => {
      onChangeTimer(e.target.value);

      setTimerValue(e.target.value);
    };

    const onInsertMember = (e, teamMemberName) => {
      e.preventDefault();
      const filterSameName = memberList.find(item => item === teamMemberName);

      if (teamMemberName.trim().length === 0) {
        e.preventDefault();

        setOpen_inputWarning(true);
        setAlert("Cannot Input Empty Field");

        setTimeout(() => {
          setOpen_inputWarning(false);
        }, 2000);
      } else if (teamMemberName !== filterSameName) {
        setMemberList([...memberList, teamMemberName]);
      } else {
        setAlert("Sorry, you are not allowed to enter existing username");
        setOpen_inputWarning(true);

        setTimeout(() => {
          setOpen_inputWarning(false);
        }, 2000);
      }

      setTeamMemberName("");
    };

    const openPassword = () => {
      onOpenPassword();
    };

    // Set player analytics
    const setPlayerAnalytics = () => {
      console.log("setPlayerAnalytics");
      const baseUrl = window.themeObj.restURL;
      const apiURL = `${baseUrl}/game/game-set-player-analytics`;
      axios.post(apiURL).catch(console.error);
    }

    const handleOnStart = () => {
      // Prevent onStart when the Modal is hidden
      if (!isOpen) return null;

      const members = memberList;

      // Prevent update feed on update team (only on first setup)
      if (isFirstSetup) {
        axios.post("/wp-json/api/v1/update_feed").catch(console.error);
        setIsFirstSetup(false);
      }

      if (members.length === 0) {
        setOpen_inputWarning(true);
        setAlert(setup_team_member_input_empty_response);

        setTimeout(() => {
          setOpen_inputWarning(false);
        }, 2000);
      } else {
        onStart(members);
        onClose();
        onSetPlay();
        setTimeout(() => {
          setIsSetupSection(false);
        }, 1000);
        setPlayerAnalytics();
      }
    };

    const handleChange = e => {
      if (e.target.value.length >= 25) {
        setOpen_inputWarning(true);
        setAlert("Character limit is 25");
        setDisabled(true);

        setTimeout(() => {
          setOpen_inputWarning(false);
          setDisabled(false);
        }, 2000);
      } else {
        setIsOpen_warning(false);
      }

      setTeamMemberName(e.target.value);
    };

    const handleNextPage = () => {
      setIsSetupSection(true);
      openPassword();
      if (!isOpen) return null;
    };

    const handleClose = () => {
      setIsOpen_warning(false);
      setDisabled(false);
      isDisable();
    };

    const keyListener = event => {
      if (refEl.current.classList.contains("is-setup")) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          onInsertMember(event, teamMemberName);
        }
      }
    };

    useEffect(() => {
      setTimerValue(timerValue);

      if (login === true) {
        setIsSetupSection(true);
      }

      if (textRef.current.textContent.length >= 900) {
        setFontClass(true);
      } else {
        setFontClass(false);
      }
    }, [timerValue]);

    return (
      <>
        <div
          ref={refEl}
          className={`introduction-screen ${classOpen} ${classBlur} ${
            isSetupSection ? "is-setup" : ""
          }`}
          // style={style}
        >
          <div className="introduction-screen__left">
            <div className="introduction-screen__box">
              <div className="introduction-screen__content introduction-screen__content__instruction">
                <div className="instruction-content">
                  <h3 className="instruction-content__subtitle">
                    {welcome_subtitle}
                  </h3>
                  <h1 className="instruction-content__title">
                    {welcome_title}
                  </h1>
                  <div
                    className={`instruction-content__text ${
                      fontClass ? "high" : ""
                    }`}
                    dangerouslySetInnerHTML={{ __html: welcome_text }}
                    ref={textRef}
                  />
                </div>
                <div className="instruction-session">
                  {/* <h3 className="instruction-session__title">
                    {window.sessions.session_title}{" "}
                    <span className="instruction-session__title--bold">
                      ± {Math.round(timerValue)} minutes
                    </span>{" "}
                    {window.sessions.session_to_finish}
                  </h3> */}
                  <div className="instruction-session__input">
                    <input
                      className="input-action"
                      type="range"
                      value={timerValue}
                      min={minimumSession}
                      max={maximumSession}
                      step={5}
                      onChange={onChangeTimerValue}
                    />
                    {/* <div className="instruction-session__indicator">
                        {timerArray.map((item, index) => {
                          return (
                            <span
                              className="instruction-session__indicator-line"
                              key={index}
                              style={{
                                left: `calc(${item} * 13.33%)`
                              }}
                            />
                          );
                        })}
                      </div> */}
                    <div
                      className="instruction-session__thumb-value"
                      style={{
                        left: `${percentCalc}%`
                      }}
                    >
                      <span className="thumbVisual">
                        <span />
                      </span>
                      <span className="instruction-session__title-timer">
                        {Math.round(timerValue)}
                        <span className="instruction-session__title--bold-2">
                          min
                        </span>
                      </span>
                    </div>
                    <div className="instruction-session__placeholder">
                      <span>
                        {minimumSession}
                        <span className="instruction-session__title--bold">
                          min
                        </span>
                      </span>
                      <span>
                        {maximumSession}
                        <span className="instruction-session__title--bold">
                          min
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                {languageCodes.length > 1 && <LanguageOptionMenu />}

                <UserConsumer>
                  {value => (
                    <Link
                      className="finish-session-button"
                      to={usePassword ? "/password-page" : "/"}
                      state={{ value }}
                    >
                      <Button
                        className="play"
                        {...instructionPageButton}
                        onClick={handleNextPage}
                      />
                    </Link>
                  )}
                </UserConsumer>
              </div>
              <div className="introduction-screen__content introduction-screen__content__setup team">
                <div className="instruction-content">
                  <h3
                    className="instruction-content__subtitle"
                    style={{
                      left: `${percentCalc}%`
                    }}
                  >
                    {setup_team_subtitle}
                  </h3>
                  <h1 className="instruction-content__title">
                    {setup_team_title}
                  </h1>
                  <div
                    className="instruction-content__text"
                    dangerouslySetInnerHTML={{ __html: setup_team_desc }}
                  />
                </div>
                {/* <div className="instruction-setup__input">
                      <h3 className="instruction-setup__title">Team Name</h3>
                      <div className="instruction-setup__input-container">
                        <input
                          className="instruction-setup__input-team"
                          type="text"
                          placeholder="Team Name"
                          onChange={e => setTeamName(e.target.value)}
                        />
                      </div>
                    </div> */}
                <div className="instruction-setup__input">
                  <h3 className="instruction-setup__title">
                    {setup_team_member_title}
                  </h3>
                  <div className="instruction-setup__input-container">
                    <input
                      onKeyDown={keyListener}
                      className="instruction-setup__input-member"
                      type="text"
                      placeholder={setup_team_member_input_placeholder}
                      value={teamMemberName}
                      onChange={handleChange}
                      disabled={isDisabled}
                    />
                    <button
                      type="button"
                      onClick={e => onInsertMember(e, teamMemberName)}
                      className="instruction-setup__add-button"
                    >
                      +
                    </button>
                  </div>
                  <div
                    className={
                      isOpen_inputWarning ? `input-warning` : `close-warning`
                    }
                  >
                    <p>{isAlert}</p>
                  </div>
                </div>
                <div className="instruction-setup__member-list">
                  {memberList.map((item, index) => (
                    <Item
                      key={index}
                      item={item}
                      removeItem={() =>
                        setMemberList(
                          memberList.filter(member => member !== item)
                        )
                      }
                    />
                  ))}
                </div>
                <Button
                  className="play"
                  {...playGameButton}
                  onClick={handleOnStart}
                />
              </div>
            </div>
          </div>
          <div className="introduction-screen__spinner">
            <Wheel
              members={members}
              data={categoryList}
              {...wheel}
              diameter={500}
            />
            <ProgressBar
              currentRound="-"
              totalRound=""
              isDisplayContent={false}
            />
          </div>
        </div>
        <div className={isOpen_warning ? `open-warning` : `close-warning`}>
          <div className="open-warning-content">
            <div className="open-warning-content__content">
              <h1>{isAlert}</h1>
            </div>
            <div className="open-warning-content__close-button">
              <button
                onClick={() => handleClose()}
                className="button-text"
                title="close"
              >
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path
                    d="M25.5 8.5L8.5 25.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.5 8.5L25.5 25.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default introductionScreen;
